import axios from "axios";

export const enviarNotificacion = async (reserva) => {


    let data = JSON.stringify({
        "numero": reserva.celular,
        "indicativo": reserva.indicativo,
        "nombre": reserva.nombres,
        "cc": reserva.cc,
        "habitacion": reserva.numero,
        "valor": reserva.valor,
        "fechaCheckIn": reserva.fechaCheckIn,
        "fechaCheckOut": reserva.fechaCheckOut,
        "numAcompanantes": reserva.numAcompanantes,
        "numNinos": reserva.numNinos,
        "link": reserva.link,
        "img": reserva.img,
    });

    let config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: 'https://ingenieria-n8n.iotr9n.easypanel.host/webhook/59b0fb13-c6f0-46aa-8b88-ed11feb4984c',
       // url: 'https://ingenieria-n8n.iotr9n.easypanel.host/webhook-test/59b0fb13-c6f0-46aa-8b88-ed11feb4984c',//test
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Basic QWRtaW46MTIzNDU2'
        },
        data: data
    };

    axios.request(config)
        .then((response) => {
            console.log(JSON.stringify(response.data));
        })
        .catch((error) => {
            console.log(error);
        });


}